export default "__VITE_ASSET__DpXZKZsp__"